import { useContext, useState } from "react";
import { Modal } from "flowbite-react";
import { addDays } from "date-fns";

import { DatePicker } from "../../components";
import UserContext from "../../../contexts/UserContext";
import restService from "../../../restService";

const ActivatePromoStation = ({ showModal, onClose, value }) => {
  const[pending, setPending] = useState(false)
  const [user] = useContext(UserContext);

  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 1),
      key: "selection",
    },
  ]);

  const handleActivatePromoStation = async () => {
    setPending(true)

    try {
      const data = {
        name: value.name,
        location: value.location,
        activationStartDate: dateRange[0].startDate,
        activationEndDate: dateRange[0].endDate,
      };

      await restService.Management.activatePromoStation(
        user.token,
        value.campaignId,
        value.stationId,
        data
      );
    } catch (err) {
      console.log(err);
    } finally {
      setPending(false)
      onClose();
    }
  };

  return (
    <Modal onClose={onClose} show={showModal}>
      <div className="p-8 w-full flex flex-col gap-10">
        <div>
          <h3 className="text-lg font-bold text-gray-800 capitalize">
            activate station
          </h3>
        </div>
        <div className="grid grid-cols-2 grid-rows-2 gap-5">
          <div className="flex flex-col gap-3">
            <label className="capitalize text-base text-gray-700">
              station name
            </label>
            <input
              className="rounded-md bg-gray-200 text-gray-500 cursor-not-allowed"
              type="text"
              defaultValue={value?.name}
              placeholder="station name"
            />
          </div>
          <div className="flex flex-col gap-3">
            <label className="capitalize text-base text-gray-700">zone</label>
            <input
              className="rounded-md bg-gray-200 text-gray-500 cursor-not-allowed"
              type="text"
              defaultValue={value?.zone}
              placeholder="station zone"
            />
          </div>
          <div className="flex flex-col gap-3">
            <label className="capitalize text-base text-gray-700">
              duration
            </label>
            <DatePicker state={dateRange} setState={setDateRange} />
          </div>
        </div>
        <div className="flex justify-around items-center min-w-fit w-1/2 mx-auto">
          <button
            className="px-10 py-3 border rounded-sm text-red-400 text-lg capitalize"
            onClick={onClose}
          >
            cancel
          </button>
          {pending ? (
            <button
              disabled
              className="capitalize py-2 hover:bg-blue-50 hover:border-blue-500 hover:border-2 hover:text-blue-500 hover:font-bold  px-16 rounded-md text-white bg-blue-500"
            >
              activating promo...
            </button>
          ) : (
            <button
              onClick={handleActivatePromoStation}
              className="px-10 py-3 bg-blue-500 text-white text-lg rounded-md capitalize"
            >
              done
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ActivatePromoStation;
